import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-label-input',
  templateUrl: './label-input.component.html',
  styleUrls: ['./label-input.component.scss'],
})
export class LabelInputComponent {
  @Input() label: string;
  @Input() value: any;

  constructor() { }
}
